<template>
  <Dialog type="history" :show="$bus.history.show" :title="$bus.transify['FLIP_HISTORY']">
    <template v-slot:dialog-content>
      <div class="history-content">
        <ul class="history-list" ref="historyList">
          <template v-for="history in History" >
            <ItemLine class="history-list-item" :key="history.time" :time="formateTime(history.time)" :history="history"/>
          </template>
        </ul>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from '@/components/common/Dialog.vue'
import ItemLine from '@/components/history/item.vue'
import { getTime, compare } from '@/utils/assist'
export default {
  components: {
    Dialog,
    ItemLine
  },
  data () {
    return {
      activeIdx: 0
    }
  },
  watch: {
    '$bus.history.show': {
      handler (val) {
        if (!val) {
          this.$refs.historyList.scrollTop = 0
        }
      }
    }
  },
  computed: {
    History () {
      const initHistory = this.$bus.history.data
      const history = []
      for (let item of initHistory) {
        history.push({
          time: item.created_at,
          price: item.cost,
          type: item.type,
          pool: item.item_pool || '',
          name: item.item_name || '',
          nums: item.item_num || '',
          src: item.item_img || ''
        })
      }
      return history.sort(compare('time', 'des'))
    }
  },
  methods: {
    formateTime (time) {
      return getTime(time)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-content {
  width: 100%;
  .history-list {
    width: 94%;
    overflow: hidden;
    overflow-y: auto;
    margin: 0 auto;
    @include px2res(padding, 0, 20);
    @include px2res(height, 106 * 3);
    .history-list-item {
      border-bottom: 2px solid rgba(255, 160, 51, .3);
    }
    .history-list-item:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/history/index.vue